import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Rect,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Rect, { width: "18", height: "10", x: "3", y: "11", rx: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "5", r: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 7v4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "8", x2: "8", y1: "16", y2: "16", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "16", x2: "16", y1: "16", y2: "16", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Bot";
const Bot = memo(themed(Icon));
export {
  Bot
};
//# sourceMappingURL=bot.js.map
